import type { Component } from 'vue';
import { isElement, isObject, isString } from 'lodash'

import type { PopupOptions } from '../component'
import type { OverlayOptions } from '../plugin';
import { OverlayPlugin } from '../plugin';
import { PopupLayer } from '../component';

declare module '@vue/runtime-core' {
    interface ComponentCustomProperties {
        $popup: typeof popup
    }
}

export function popup(this: { $overlay: OverlayPlugin },
    component: Component,
    tooltipOptionsOrAnchor: PopupOptions|Element|DOMRect,
    props?: Record<string, any>,
    optionsOrId?: OverlayOptions|string){

    const $overlay: OverlayPlugin = this['$overlay'];
    if(!$overlay){
        throw 'No overlay plugin available to show popup';
    }

    const tooltipOptions = tooltipOptionsOrAnchor || {};
    let resolvedTooltipOptions: PopupOptions = tooltipOptions as PopupOptions;
    let andorDomRect = tooltipOptions as DOMRect;

    if(isElement(tooltipOptions) || (isObject(tooltipOptions) && (andorDomRect.left || andorDomRect.top || andorDomRect.width || andorDomRect.height))){
        resolvedTooltipOptions = { anchor: tooltipOptionsOrAnchor as any }
    }

    const resolvedOptions: OverlayOptions = isString(optionsOrId) ? { id: optionsOrId } : optionsOrId;

    const fullOptions: OverlayOptions = {
        animate: false,
        pointerEvents: true,
        blocking: true,
        ...resolvedOptions,
        layer: PopupLayer,
        tooltipOptions: resolvedTooltipOptions
    };

    return $overlay.show(component, props, fullOptions);
}

export const popupMixin = {

    methods: {
        $popup: popup
    }
}

export default popupMixin;